module.exports = __webpack_public_path__ + "static/media/icon-starterkit.9cad2552.png";